import axios from "axios";
import { environment } from "environments/environment";
import { onRequestSuccess, onResponseRejected } from "./interceptors";

const signupInstance = axios.create({
    baseURL: `${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/signup`
});

signupInstance.interceptors.request.use(onRequestSuccess, undefined);
signupInstance.interceptors.response.use(undefined, onResponseRejected);

export default signupInstance;
